const GET_CURRENCIES_SUCCESS = 'GET_CURRENCIES_SUCCESS';
const GET_CURRENCIES_FAIL = 'GET_CURRENCIES_FAIL';
import { getSession } from '../../../actions/session';
import client from '../../../apollo';
import { gql } from '@apollo/client'

const initialState = {
  currencies: [],
  currenciesLoaded: false,
  currenciesError: false
};

export const ALL_CURRENCIES_CODE = '%';

export default function reducer(state = initialState, { data, type }) {
  switch (type) {
    case GET_CURRENCIES_SUCCESS:
      return { ...state, currencies: data, currenciesLoaded: true, currenciesError: false };
    case GET_CURRENCIES_FAIL:
      return { ...state, currenciesError: true };
    default:
      return state;
  }
}

const currencyQuery = gql`
  query currencies {
    currencies {
      id
      code
      name
    }
  }
`;

export const getCurrencies = () => async dispatch => {
  try {
    const result = await client.query({
      query: currencyQuery,
      fetchPolicy: 'network-only'
    });

    dispatch({
      type: GET_CURRENCIES_SUCCESS,
      data: result.data.currencies
    });
  } catch (err) {
    console.log('request for list of currencies failed', err);
    dispatch({ type: GET_CURRENCIES_FAIL });
  }
};

const setCurrencyMutation = gql`
  mutation setCurrency($id: Int) {
    setCurrency(id: $id) {
      id
      name
      code
    }
  }
`;

export const setCurrency = currency => async dispatch => {
  try {
    await client.mutate({
      mutation: setCurrencyMutation,
      variables: { id: currency.id }
    });

    getSession()(dispatch);
  } catch (err) {
    console.log('could not change currency: ', err);
    console.log(err);
  }
};
